import React, { useState, useEffect } from 'react';
import { t } from '../i18n';
import { useNavigate, Link } from 'react-router-dom';

const BACKEND = '/api';

const CATEGORIES = [
  { value: '', label: 'All Categories', icon: '🌍' },
  { value: 'food', label: 'Food & Restaurant', icon: '🍔' },
  { value: 'retail', label: 'Retail & Shopping', icon: '🛍️' },
  { value: 'services', label: 'Services', icon: '⚙️' },
  { value: 'health', label: 'Health & Beauty', icon: '💊' },
  { value: 'tech', label: 'Technology', icon: '💻' },
  { value: 'education', label: 'Education', icon: '📚' },
  { value: 'travel', label: 'Travel & Tourism', icon: '✈️' },
  { value: 'other', label: 'Other', icon: '📦' },
];

export default function MerchantDirectory() {
  const [merchants, setMerchants] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [country, setCountry] = useState('');
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('grid'); // grid | list
  const navigate = useNavigate();

  useEffect(() => { fetchMerchants(); }, []);

  useEffect(() => {
    let result = merchants;
    if (search) result = result.filter(m => m.business_name.toLowerCase().includes(search.toLowerCase()) || m.tagline?.toLowerCase().includes(search.toLowerCase()));
    if (category) result = result.filter(m => m.category === category);
    if (country) result = result.filter(m => m.country === country);
    setFiltered(result);
  }, [search, category, country, merchants]);

  const fetchMerchants = async () => {
    try {
      const r = await fetch(`${BACKEND}/merchants/list/`);
      const d = await r.json();
      setMerchants(d.merchants || []);
      setFiltered(d.merchants || []);
    } catch(e) {}
    setLoading(false);
  };

  const countries = [...new Set(merchants.map(m => m.country))].filter(Boolean).sort();

  return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', color: '#fff', fontFamily: 'Arial, sans-serif' }}>
      
      {/* Yellow Pages Header */}
      <div style={{ background: 'linear-gradient(135deg, #0F6E56 0%, #e6950a 100%)', padding: '30px 20px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
            <div style={{ fontSize: 48 }}>📒</div>
            <div>
              <h1 style={{ color: '#000', fontSize: 32, margin: 0, fontWeight: 'bold' }}>{t('md_title')}</h1>
              <p style={{ color: '#333', margin: 0, fontSize: 14 }}>{t('md_tag')}</p>
            </div>
            <div style={{ marginLeft: 'auto', background: '#000', color: '#0F6E56', padding: '6px 14px', borderRadius: 20, fontSize: 13, fontWeight: 'bold' }}>
              🥧 {merchants.length} Pi Merchants
            </div>
          </div>

          {/* Search Bar */}
          <div style={{ display: 'flex', gap: 8, background: '#fff', borderRadius: 12, padding: 8, marginTop: 16 }}>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder={t('md_search_ph')}
              style={{ flex: 1, border: 'none', outline: 'none', fontSize: 16, padding: '8px 12px', color: '#333' }}
            />
            <button style={{ background: '#0F6E56', border: 'none', borderRadius: 8, padding: '8px 20px', fontWeight: 'bold', cursor: 'pointer', fontSize: 15 }}>{t('md_search')}</button>
          </div>
        </div>
      </div>

      {/* Category Bar */}
      <div style={{ background: '#1a1a2e', borderBottom: '1px solid #2a2a4a', overflowX: 'auto' }}>
        <div style={{ display: 'flex', gap: 4, padding: '12px 20px', maxWidth: 1200, margin: '0 auto' }}>
          {CATEGORIES.map(c => (
            <button key={c.value} onClick={() => setCategory(c.value)}
              style={{ padding: '8px 16px', background: category === c.value ? '#0F6E56' : 'transparent', color: category === c.value ? '#000' : '#aaa', border: '1px solid ' + (category === c.value ? '#0F6E56' : '#2a2a4a'), borderRadius: 20, cursor: 'pointer', whiteSpace: 'nowrap', fontSize: 13, fontWeight: category === c.value ? 'bold' : 'normal' }}>
              {c.icon} {c.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: 20 }}>
        
        {/* Filters + Stats */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            <select value={country} onChange={e => setCountry(e.target.value)}
              style={{ padding: '8px 14px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 14 }}>
              <option value="">🌍 {t('md_all_countries')}</option>
              {countries.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <span style={{ color: '#aaa', fontSize: 14 }}>Showing {filtered.length} merchants</span>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => setView('grid')} style={{ padding: '8px 14px', background: view === 'grid' ? '#0F6E56' : '#1a1a2e', color: view === 'grid' ? '#000' : '#fff', border: '1px solid #2a2a4a', borderRadius: 8, cursor: 'pointer' }}>⊞ {t('md_grid')}</button>
            <button onClick={() => setView('list')} style={{ padding: '8px 14px', background: view === 'list' ? '#0F6E56' : '#1a1a2e', color: view === 'list' ? '#000' : '#fff', border: '1px solid #2a2a4a', borderRadius: 8, cursor: 'pointer' }}>≡ {t('md_list')}</button>
            <button onClick={() => navigate('/merchants')} style={{ padding: '8px 14px', background: '#1a1a2e', color: '#0F6E56', border: '1px solid #0F6E56', borderRadius: 8, cursor: 'pointer' }}>🗺️ {t('md_map')}</button>
          </div>
        </div>

        {/* Stats Row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginBottom: 24 }}>
          {CATEGORIES.slice(1).map(c => {
            const count = merchants.filter(m => m.category === c.value).length;
            if (count === 0) return null;
            return (
              <div key={c.value} onClick={() => setCategory(c.value)}
                style={{ background: '#1a1a2e', border: '1px solid ' + (category === c.value ? '#0F6E56' : '#2a2a4a'), borderRadius: 12, padding: '12px', textAlign: 'center', cursor: 'pointer' }}>
                <div style={{ fontSize: 24 }}>{c.icon}</div>
                <div style={{ color: '#0F6E56', fontWeight: 'bold', fontSize: 20 }}>{count}</div>
                <div style={{ color: '#aaa', fontSize: 11 }}>{c.label}</div>
              </div>
            );
          }).filter(Boolean)}
        </div>

        {/* Merchant Grid */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#aaa' }}>⏳ {t('md_loading')}</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60 }}>
            <div style={{ fontSize: 64 }}>📒</div>
            <h3 style={{ color: '#0F6E56' }}>{t('md_none')}</h3>
            <p style={{ color: '#aaa' }}>{t('md_first')}</p>
            <button onClick={() => navigate('/merchants')} style={{ padding: '12px 24px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold', marginTop: 12 }}>
              + Register as Merchant
            </button>
          </div>
        ) : view === 'grid' ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
            {filtered.map(m => <GridCard key={m.id} merchant={m} onClick={() => navigate(`/merchants/${m.slug || m.id}`)} />)}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {filtered.map(m => <ListCard key={m.id} merchant={m} onClick={() => navigate(`/merchants/${m.slug || m.id}`)} />)}
          </div>
        )}
      </div>
    </div>
  );
}

function GridCard({ merchant: m, onClick }) {
  const cat = CATEGORIES.find(c => c.value === m.category);
  return (
    <div onClick={onClick} style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20, cursor: 'pointer', transition: 'all 0.2s' }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = '#0F6E56'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a4a'; e.currentTarget.style.transform = 'translateY(0)'; }}>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
        <div style={{ fontSize: 36 }}>{cat?.icon || '🏪'}</div>
        <div style={{ display: 'flex', gap: 6, flexDirection: 'column', alignItems: 'flex-end' }}>
          {m.is_verified && <span style={{ background: '#22c55e', color: '#000', fontSize: 10, padding: '2px 8px', borderRadius: 10, fontWeight: 'bold' }}>✓ {t('md_verified')}</span>}
          {m.pi_discount > 0 && <span style={{ background: '#0F6E56', color: '#000', fontSize: 10, padding: '2px 8px', borderRadius: 10, fontWeight: 'bold' }}>🎁 {m.pi_discount}% off</span>}
        </div>
      </div>
      
      <h3 style={{ margin: '0 0 4px', fontSize: 18, color: '#fff' }}>{m.business_name}</h3>
      <p style={{ color: '#aaa', fontSize: 13, margin: '0 0 12px', lineHeight: 1.4 }}>{m.tagline || 'Pi-accepting merchant'}</p>
      
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <span style={{ background: '#0d1b2a', color: '#0F6E56', fontSize: 11, padding: '3px 10px', borderRadius: 10 }}>{cat?.icon} {cat?.label}</span>
        {m.city && <span style={{ background: '#0d1b2a', color: '#aaa', fontSize: 11, padding: '3px 10px', borderRadius: 10 }}>📍 {m.city}</span>}
        {m.country && <span style={{ background: '#0d1b2a', color: '#aaa', fontSize: 11, padding: '3px 10px', borderRadius: 10 }}>🌍 {m.country}</span>}
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #2a2a4a', paddingTop: 12 }}>
        <span style={{ color: '#0F6E56', fontSize: 13 }}>🥧 @{m.pi_username}</span>
        <span style={{ color: '#aaa', fontSize: 12 }}>{'⭐'.repeat(Math.round(m.avg_rating || 0))} ({m.total_reviews || 0})</span>
      </div>
    </div>
  );
}

function ListCard({ merchant: m, onClick }) {
  const cat = CATEGORIES.find(c => c.value === m.category);
  return (
    <div onClick={onClick} style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 12, padding: '16px 20px', cursor: 'pointer', display: 'flex', gap: 16, alignItems: 'center' }}
      onMouseEnter={e => e.currentTarget.style.borderColor = '#0F6E56'}
      onMouseLeave={e => e.currentTarget.style.borderColor = '#2a2a4a'}>
      <div style={{ fontSize: 36, minWidth: 50, textAlign: 'center' }}>{cat?.icon || '🏪'}</div>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <h3 style={{ margin: 0, fontSize: 16, color: '#fff' }}>{m.business_name}</h3>
          {m.is_verified && <span style={{ background: '#22c55e', color: '#000', fontSize: 10, padding: '2px 8px', borderRadius: 10, fontWeight: 'bold' }}>✓</span>}
          {m.pi_discount > 0 && <span style={{ background: '#0F6E56', color: '#000', fontSize: 10, padding: '2px 8px', borderRadius: 10, fontWeight: 'bold' }}>🎁 {m.pi_discount}%</span>}
        </div>
        <p style={{ color: '#aaa', fontSize: 13, margin: '0 0 6px' }}>{m.tagline}</p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {m.city && <span style={{ color: '#aaa', fontSize: 12 }}>📍 {m.city}, {m.country}</span>}
          <span style={{ color: '#0F6E56', fontSize: 12 }}>🥧 @{m.pi_username}</span>
          <span style={{ color: '#aaa', fontSize: 12 }}>{'⭐'.repeat(Math.round(m.avg_rating || 0))} ({m.total_reviews || 0})</span>
        </div>
      </div>
      <div style={{ color: '#0F6E56', fontSize: 20 }}>→</div>
    </div>
  );
}
